module.exports = __webpack_public_path__ + "img/antes_despues_159.c3eafd5f.png";